// frontend/src/services/api.js
import axios from 'axios';

const api = axios.create({
  baseURL: '/library-api/api',
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 60000,
  withCredentials: false,
});

export default api;
